import React, { useEffect, useState } from "react";
import Modal from "./Modal";
import { Close, Loader } from "../icons";
import Input from "../common/Input";
import SelectInput from "../common/SelectInput";

export default function UserModal({
  open,
  onClose,
  onSubmit,
  mode = "add",
  initialValues = {},
  campusOptions = [],
  roleOptions = [],
  isLoading = false,
}) {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    password: "",
    campusId: "",
    roles: [],
  });

  useEffect(() => {
    if (!open) return;

    if (mode === "edit" && initialValues) {
      const campusId =
        typeof initialValues?.campus === "object" && initialValues.campus?._id
          ? initialValues.campus._id
          : initialValues?.campusId || initialValues?.campus || "";

      const roles = Array.isArray(initialValues?.roles)
        ? initialValues.roles.map((role) =>
            typeof role === "object" ? role._id : role,
          )
        : [];

      setFormData({
        name: initialValues?.name || "",
        email: initialValues?.email || "",
        password: "",
        campusId,
        roles,
      });
      return;
    }

    setFormData({
      name: "",
      email: "",
      password: "",
      campusId: "",
      roles: [],
    });
  }, [open, mode, initialValues]);

  function handleRoleToggle(roleId) {
    setFormData((prev) => {
      const roles = prev.roles.includes(roleId)
        ? prev.roles.filter((id) => id !== roleId)
        : [...prev.roles, roleId];
      return { ...prev, roles };
    });
  }

  function handleSubmit() {
    const payload = {
      name: formData.name,
      email: formData.email,
      campusId: formData.campusId,
      roles: formData.roles,
      ...(mode !== "edit" ? { password: formData.password } : {}),
    };

    onSubmit?.(payload, mode, initialValues?._id);
  }

  const title = mode === "edit" ? "Edit User" : "Access Provisioning";
  const submitLabel = mode === "edit" ? "Save Changes" : "Grant Access";

  return (
    <Modal
      open={open}
      onClose={onClose}
      title={null}
      panelClassName="max-w-[620px] pt-8 pb-9 px-0 max-h-[95vh] overflow-hidden flex flex-col rounded-[15px]"
      centered={false}
    >
      <div className="w-full">
        <div className="flex items-center justify-between mb-7 pl-8 pr-7 shrink-0">
          <p className="text-xl font-bold leading-6 text-black">{title}</p>
          <button onClick={onClose} aria-label="close">
            <Close />
          </button>
        </div>

        <div className="border-t border-[#E5E5E5] pt-8 px-8 overflow-y-auto" style={{ maxHeight: "calc(95vh - 100px)" }}>
          <Input
            label="Full Name"
            value={formData.name}
            onChange={(e) => setFormData({ ...formData, name: e.target.value })}
            placeholder="Enter full name"
          />
          <div className="grid grid-cols-2 gap-4 mt-8 mb-8">
            <Input
              label="Work Email"
              type="email"
              value={formData.email}
              onChange={(e) =>
                setFormData({ ...formData, email: e.target.value })
              }
              placeholder="Enter email address"
              readOnly={mode === "edit"}
            />

            {mode !== "edit" && (
              <Input
                label="Initial Password"
                type="password"
                value={formData.password}
                onChange={(e) =>
                  setFormData({ ...formData, password: e.target.value })
                }
                placeholder="Enter password"
              />
            )}
          </div>
          <SelectInput
            label="Assign to Campus"
            options={campusOptions.map((campus) => ({
              label: campus.name,
              value: campus._id,
            }))}
            value={formData.campusId}
            onChange={(value) => setFormData({ ...formData, campusId: value })}
            placeholder="Select campus"
          />

          <div className="mt-5">
            <label className="block text-sm leading-6 text-[#7E7E7E]">System Roles (Multi-select)</label>
            <div className="mt-5 grid grid-cols-2 gap-x-4 gap-y-5 max-h-[160px] sm:max-h-[220px] overflow-y-auto pr-2 custom-scrollbar">
              {roleOptions.map((role) => {
                const active = formData.roles.includes(role._id);
                return (
                  <button
                    key={role._id}
                    type="button"
                    onClick={() => handleRoleToggle(role._id)}
                    className={`rounded-[10px] leading-6  px-3 py-2 text-sm transition ${
                      active
                        ? " bg-[#6D4E8A] text-white"
                        : " bg-[#F2F2F2] text-black"
                    }`}
                  >
                    {role.roleName}
                  </button>
                );
              })}
            </div>
          </div>

          <div className="mt-10">
           
            <button
              type="button"
              onClick={handleSubmit}
              disabled={isLoading}
              className="w-full bg-[#6D4E8A] text-white py-[10px] text-sm rounded-[5px] flex items-center justify-center gap-2 disabled:opacity-70"
            >
              {isLoading && <Loader />}
              {isLoading ? "Processing" : submitLabel}
            </button>
          </div>
        </div>
      </div>
    </Modal>
  );
}
